import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// Actions
import {
  fetchDataInformation,
  setFieldInformation,
  setFieldShipping,
} from "../actions/checkoutStore";

// Components
import { LoadingIcon } from "./LoadingIcon";
import StepsTemplate from "../templates/stepsTemplate";
import InformationContent from "./InformationContent";
import CheckStep from "../utils/CheckStep";

export default function Information({ stripePromise }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const isFirstRun = useRef(true);
  const mediaWatcher = window.matchMedia("(max-width: 992px)");

  function changeStoreInformationField(field, value) {
    dispatch(setFieldInformation(field, value));
  }

  function updateMobile(e) {
    changeStoreInformationField("is_mobile", mediaWatcher.matches);
  }

  // The SinglePage.js already calls this and needs to be there, in case the user refreshes the page
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const previewMode = queryParams.get("preview_mode") || "false";
    dispatch(fetchDataInformation(previewMode));
  }, []);

  useEffect(() => {
    if (
      state.checkoutStore.shipping?.pickup_points &&
      state.checkoutStore.shipping?.pickup_points.length == 1
    ) {
      dispatch(
        setFieldShipping(
          "pickup_point_id",
          state.checkoutStore.shipping.pickup_points[0].id,
        ),
      );
      dispatch(
        setFieldShipping(
          "pickup_point_name",
          state.checkoutStore.shipping.pickup_points[0].name,
        ),
      );
    }
  }, [state.checkoutStore.shipping?.pickup_points]);

  useEffect(() => {
    if (isFirstRun.current) {
      if (mediaWatcher.addEventListener) {
        mediaWatcher.addEventListener("change", updateMobile);
      } else {
        mediaWatcher.addListener(updateMobile);
      }

      isFirstRun.current = false;
      return;
    }
  }, [state.checkoutStore.information]);

  if (state.ui.isLoading) {
    return <LoadingIcon default />;
  }

  const currentUrl = window.location.href;
  const redirectUrl = CheckStep(state, currentUrl);
  if (redirectUrl) navigate(redirectUrl);

  return (
    <StepsTemplate>
      <InformationContent stripePromise={stripePromise} vertical={false} />
    </StepsTemplate>
  );
}
